const IconArrowLeft = (): JSX.Element => {
  return (
    <>
      <path
        clipRule="evenodd"
        d="M18.5.7c.9.9.9,2.4,0,3.4l-7.9,7.9,7.9,7.9c.9.9.9,2.4,0,3.4s-2.4.9-3.4,0L5.5,13.7c-.9-.9-.9-2.4,0-3.4L15.1.7c.9-.9,2.4-.9,3.4,0Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  );
};

export default IconArrowLeft;
